import { formatDataTest } from '@/common/dataTest/DataTest';
import { useTab } from '@/common/entityFramework/entityDetail/TabContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import { useState } from 'react';

export const FormSection = ({ title, children }) => {

  const { navState, assign } = useNavState();
  const { tabId } = useTab();

  const formSectionsNavStateKey = tabId + 'FormSections';

  const [expanded, setExpanded] = useState(() => {
    const formSectionsNavState = navState[formSectionsNavStateKey] ?? {};
    return formSectionsNavState[title] ?? title !== 'Audit'
  });

  const handleToggle = () => {
    setExpanded(prev => {

      const newExpanded = !prev;

      const formSectionsNavState = navState[formSectionsNavStateKey] ?? {};
      formSectionsNavState[title] = newExpanded;

      assign(formSectionsNavStateKey, formSectionsNavState);

      return newExpanded;
    });
  };

  return (
    <Box
      sx={theme => ({
        bgcolor: theme.palette.mode !== 'dark' ? theme.palette.primary.light : theme.palette.background.paper,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        mb: 2,
        boxShadow: 0,
      })}
    >
      <Box
        data-test-id={formatDataTest('form-section', title, 'title')}
        onClick={handleToggle}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          cursor: 'pointer',
          borderBottom: expanded ? 'none' : undefined,
        }}
      >
        <Typography variant="subtitle1">{title}</Typography>
        <IconButton
          size="small"
          sx={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
          }}
        >
          <FontAwesomeIcon icon={fas.faChevronDown} />
        </IconButton>
      </Box>
      <Collapse data-test-id={formatDataTest('form-section', title, 'expansion')} in={expanded} timeout="auto" unmountOnExit={false}>
        <Box
          sx={{
            px: 2,
            py: 2,
            // borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};